import { Component, OnInit } from '@angular/core';
import { BusinessLoanState } from '../../../states/business-loan-state';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { StepOneState } from '../../../states/loan-steps/step-one-state';
import { StepTwoState } from '../../../states/loan-steps/step-two-state';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-business-loan',
    templateUrl: './business-loan.component.html',
    styleUrl: './business-loan.component.scss',
    standalone: false
})
export class BusinessLoanComponent implements OnInit {
    constructor(
        protected businessLoanState: BusinessLoanState,
        private s1: StepOneState,
        private s2: StepTwoState,
        private router: Router,
        private viewportScroller: ViewportScroller,
    ) { }

    ngOnInit(): void {
        this.tryRedirectToCorrectStep();
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd)
            )
            .subscribe((e) => {
                this.tryRedirectToCorrectStep();
                this.viewportScroller.scrollToPosition([0, 0])
            });
    }

    tryRedirectToCorrectStep() {
        const currentUrl = this.router.url;
        if (!currentUrl.includes("/loan")) return;
        if (currentUrl === "/loan/application-list") return;

        if (!this.s1.uuid) {
            this.router.navigate(["/loan/step-one"])
        } else if (!this.s2.state?.applicant.uuid && currentUrl !== "/loan/step-one" && currentUrl !== "/loan/step-two") {
            this.router.navigate(["/loan/step-two"])
        }
    }

}
